module.exports = __webpack_public_path__ + "static/media/secondario.72a0c996.png";